import { render, staticRenderFns } from "./ProductProviderSettingsForm.vue?vue&type=template&id=57733af2"
import script from "./ProductProviderSettingsForm.vue?vue&type=script&lang=js"
export * from "./ProductProviderSettingsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports